import styled from 'styled-components';

export const ButtonBox = styled.div`
  width: fit-content;

  @media (max-width: 768px) {
    width: 100%;
  }
`;
